import useGetBookingSummary from '@/features/dashboard/bookingChanges/hooks/useGetBookingSummary.ts';
import BookingStateCard from './BookingStateCard';
import BookingStateCardSkeleton from './BookingStateCardSkeleton';

interface BookingStateSectionProps {
  bookingId: string;
}

/** Stan rezerwacji — panel boczny w trybie podglądu. */
const BookingStateSection = ({ bookingId }: BookingStateSectionProps) => {
  const summaryQuery = useGetBookingSummary(bookingId);

  if (summaryQuery.isLoading) {
    return <BookingStateCardSkeleton />;
  }

  if (!summaryQuery.data) {
    return null;
  }

  return (
    <BookingStateCard
      summary={summaryQuery.data}
      bookingLink={{
        to: '/app/bookings/$bookingId/booking',
        params: { bookingId: summaryQuery.data.bookingId },
      }}
    />
  );
};

export default BookingStateSection;
